import React from 'react';
import anchorme from 'anchorme';
import { ReactComponent as EventsIcon } from './icons/events.svg';
import BlockContainer from '../BlockComponents/BlockContainer';
import BlockContentContainer from '../BlockComponents/BlockContentContainer';
import BlockTextContainer, { BlockSubTextContainer } from '../BlockComponents/BlockTextContainer';
import styled from 'styled-components';
import { IEventsBlockPreviewProps } from './IEventsBlockPreviewProps';
import PageBuilderService from 'api/services/page-builder';
import EventsBlockEventPreview from './EventsBlockEventPreview';

const EventsBlockContainer: any = styled.div`
  width: 100%;
  margin-top: 25px;
`;

const EventsBlockEmptyContainer: any = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: #FFFFFF;
  padding: 80px 0;
`;

const EventsBlockEmptyIconContainer: any = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const EventsBlockEmptyTitle: any = styled.h1`
  margin: 0;
  padding: 0;
  text-align: center;
  margin-top: 20px;
  font-weight: 500;
  font-size: 24px;
  line-height: 29.05px;
 color: #191b1f;
`;

const EventsBlockEmptySubtext: any = styled.p`
  margin: 0;
  padding: 0;
  text-align: center;
  margin-top: 10px;
  font-weight: 400;
  font-size: 16px;
  line-height: 19.36px;
  color: #666666;
`;

const EventsBlockEventsContainer: any = styled.div<{design: any}>`
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: ${(props: any) =>
      props.design.content_container_alignment === 'center' ?
      'center' :
      props.design.content_container_alignment === 'right' ?
      'flex-end' :
      'flex-start'
    };

    &.mobile {
        padding-left: 5px;
        padding-right: 5px;
    }

    @media(max-width: 768px) {
        padding-left: 5px;
        padding-right: 5px;
    }
`;

const EventsBlockPreview: React.FC<IEventsBlockPreviewProps> = (props) => {

  const [events, setEvents] = React.useState<Array<any>>([]);

  React.useEffect(() => {
    if(props.blockData.events_range) {
      getUpcomingEventsByDays();
    }
  }, [props.blockData.events_range, props.blockData.max_events_count]);

  const getUpcomingEventsByDays = () => {
    let query = ``;

    if(props.blockData.max_events_count) {
      query = `&limit=${props.blockData.max_events_count}`;
    }

    PageBuilderService.getInstance()
    .getUpcomingEventsByDays(props.group && props.group.id, props.blockData.events_range, query)
    .then((response: any) => {
      setEvents(response.data);
    })
    .catch(() => {})
  }

  const getElements = () => {
    if(
      !(events && events.length)
    ) {
      return (
        <EventsBlockEmptyContainer
        >
          <EventsBlockEmptyIconContainer
          >
            <EventsIcon
            />
          </EventsBlockEmptyIconContainer>

          <EventsBlockEmptyTitle
          >
            Add events
          </EventsBlockEmptyTitle>

          <EventsBlockEmptySubtext
          >
            Select upcoming events date range on the left side menu to display them here.
          </EventsBlockEmptySubtext>
        </EventsBlockEmptyContainer>
      )
    }

    return (
      <EventsBlockEventsContainer
      className={`${props.view ? props.view : ''}`}
      design={props.blockData.design}
      >
        {events.map((event: any, index: number) => (
          <EventsBlockEventPreview
          group={props.group}
          key={`${event.id}`}
          event={event}
          index={index}
          design={props.blockData.design}
          buildingPreview={props.buildingPreview}
          view={props.view}
          />
        ))}
      </EventsBlockEventsContainer>
    )

  }

  return (
    <BlockContainer
    design={props.blockData.design}
    >
        <BlockContentContainer
        className={`${props.view ? props.view : ''}`}
        design={props.blockData.design}
        >
          <BlockTextContainer
          design={props.blockData.design}
          pageStyles={props.pageStyles}
          textKey="heading"
          fallbackTextColor="#000000"
          dangerouslySetInnerHTML={{
              __html: anchorme(props.blockData.heading),
          }}
          />

          <BlockSubTextContainer
          design={props.blockData.design}
          pageStyles={props.pageStyles}
          textKey="subtext"
          fallbackTextColor="#666666"
          dangerouslySetInnerHTML={{
              __html: anchorme(props.blockData.subtext),
          }}
          />

          <EventsBlockContainer
          design={props.blockData.design}
          >
            {getElements()}
          </EventsBlockContainer>
        </BlockContentContainer>
    </BlockContainer>
  )
}

export default EventsBlockPreview;